import { Signal } from "@lit-labs/signals";
import type { PostsQueryResult } from "api-contracts/rpc/posts-query";
import type { GetPostResult } from "api-contracts/rpc/get-post";
import type { IWritableBackofficePostsState } from "./types";

export class BackofficePostsState implements IWritableBackofficePostsState {
  readonly posts = new Signal.State<PostsQueryResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
  readonly singlePost = new Signal.State<Map<string, GetPostResult>>(new Map());
  readonly singlePostLoading = new Signal.State<Set<string>>(new Set());
}
